module.exports = __webpack_public_path__ + "img/chevron-left.9cc4defe.svg";